
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"6","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"59hda","d":"M1738.766 1031.006h-1.81V1038h-2.681v-6.994H1733v-2.472h1.275v-1.6c0-1.145.501-2.934 2.706-2.934l1.987.008v2.4h-1.442c-.235 0-.569.127-.569.673v1.453H1739z"}})]),_c('use',{attrs:{"fill":"#ffdb4d","xlink:href":"#59hda","transform":"translate(-1733 -1024)"}})])
          )
        }
      }
    